import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-file-picker-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinner],
})
export class SpinnerComponent {
  @Input() progress!: number;
  @Input() diameter!: number;
  @Input() strokeWidth!: number;
  @Input() ariaLabel!: string;
}
